import { STAFF_STATUS } from '@/models/channels'
import { getCounters } from '@/utils/channel'
import Logger, { EventName, LogLevel, ProviderType } from '@/wrappers/logger'

const loggedStaff = state => state.loggedStaff

const isLoggedStaffOnCall = state => {
  return state.loggedStaff?.isOnCall
}

const loggedStaffCounters = (state, getters, rootState) => {
  const { counters } = state.loggedStaff || {}
  if (!counters) {
    return {
      oncall: {},
      ongoing: {},
      open: {},
      chats: {},
      channels: {},
      fupChannels: {},
      mentions: {}
    }
  }

  const {
    total: { channels, chats },
    sections
  } = counters

  const newChats = rootState.channel.drawer.newChats?.length
  const defaultResult = {
    unreadMessages: 0,
    privateUnreadMessages: 0,
    total: 0,
    totalHighlighted: 0
  }

  let chatsCounter = defaultResult
  try {
    chatsCounter = getCounters(sections.chats, 'chats')
  } catch (error) {
    logCounterError('chats')
  }

  let channelsCounter = defaultResult
  try {
    channelsCounter = getCounters(sections.channels, 'channels')
  } catch (error) {
    logCounterError('channels')
  }

  let fupCounters = defaultResult
  try {
    fupCounters = getCounters(sections.fupChannels, 'fupChannels')
  } catch (error) {
    logCounterError('fupChannels')
  }

  let mentionsCounters = defaultResult
  try {
    mentionsCounters = getCounters(sections.mentions, 'mentions')
  } catch (error) {
    logCounterError('mentions')
  }

  return {
    menuChats: {
      emergency: newChats,
      unreadMessages: chats.unreadMessages?.length,
      privateUnreadMessages: chats.privateUnreadMessages?.length
    },
    menuChannels: {
      emergency: fupCounters?.unreadMessages,
      unreadMessages: channels.unreadMessages?.length,
      privateUnreadMessages: channels.privateUnreadMessages?.length
    },
    // sections
    chats: {
      emergency: newChats,
      ...chatsCounter
    },
    channels: channelsCounter,
    fupChannels: fupCounters,
    mentions: mentionsCounters
  }
}

const loogedStaffId = (state, getters, rootState) => {
  return state.loggedStaff ? state.loggedStaff.id : rootState.user.user.id
}

const isLoggedStaffOnline = state => {
  return state.loggedStaff.status === STAFF_STATUS.AVAILABLE
}

const logCounterError = sectionName => {
  Logger.addLog(
    EventName.INTERACTION_ERROR,
    {
      data: {
        context: 'pagination_counter_error',
        value: sectionName
      }
    },
    {
      isAction: true,
      logLevel: LogLevel.ERROR
    },
    [ProviderType.DATADOG]
  )
}

export default {
  loggedStaff,
  loggedStaffCounters,
  isLoggedStaffOnCall,
  loogedStaffId,
  isLoggedStaffOnline
}
